module.exports = __webpack_public_path__ + "static/media/home-02.82c2009.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/videos/home-02.webm
// module id = Cw51
// module chunks = 1